'use client';

// src/providers.tsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useColorMode } from "@chakra-ui/color-mode";
import { createContext } from "@chakra-ui/react-utils";
import { css, toCSSVar } from "@chakra-ui/styled-system";
import { memoizedGet as get, runIfFn } from "@chakra-ui/utils";
import { Global, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
    theme = props.theme,
    children = props.children;
  var computedTheme = useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /* @__PURE__ */jsxs(EmotionThemeProvider, {
    theme: computedTheme,
    children: [/* @__PURE__ */jsx(CSSVars, {
      root: cssVarsRoot
    }), children]
  });
}
function CSSVars(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? ":host, :root" : _ref$root;
  var selector = [root, "[data-theme]"].join(",");
  return /* @__PURE__ */jsx(Global, {
    styles: function styles(theme) {
      return _defineProperty({}, selector, theme.__cssVars);
    }
  });
}
var _createContext = createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  StylesProvider = _createContext2[0],
  useStyles = _createContext2[1];
function createStylesContext(componentName) {
  return createContext({
    name: "".concat(componentName, "StylesContext"),
    errorMessage: "useStyles: \"styles\" is undefined. Seems you forgot to wrap the components in \"<".concat(componentName, " />\" ")
  });
}
function GlobalStyle() {
  var _useColorMode = useColorMode(),
    colorMode = _useColorMode.colorMode;
  return /* @__PURE__ */jsx(Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = get(theme, "styles.global");
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return void 0;
      var styles = css(globalStyles)(theme);
      return styles;
    }
  });
}
export { ThemeProvider, CSSVars, StylesProvider, useStyles, createStylesContext, GlobalStyle };